import { IconAlertTriangle } from "@tabler/icons-react";

export default function WarningModal({
  modal_id,
  warningDescription,
  cancel,
  confirm,
}: {
  modal_id: string;
  warningDescription: string;
  cancel: () => void;
  confirm: () => void;
}) {
  return (
    <div className="modal modal-blur fade" id={modal_id} tabIndex={-1} role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={cancel}
          ></button>
          <div className="modal-status bg-primary"></div>
          <div className="modal-body text-center py-4">
            <div className="flex justify-center">
              <IconAlertTriangle className="icon mb-2 text-primary icon-lg" />
            </div>
            <h3>Внимание</h3>
            <div className="text-muted">{warningDescription}</div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-ghost-primary" data-bs-dismiss="modal" onClick={cancel}>
              Отмена
            </button>

            <button className="btn btn-primary" data-bs-dismiss="modal" onClick={confirm}>
              Подтвердить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
